export const VOICE_RECORDING_GUIDELINES = [
    'The audio should be as close to 10 seconds as possible.',
    'The audio should include natural pauses and pacing.',
    'The audio should have minimal background noise.',
    'The model replicates the quality of the microphone, so if the recording sounds fuzzy then the output will sound fuzzy as well.',
    "The voice should be dynamic and a bit more expressive than what the final output should sound like. The voice should also have the cadence you want the cloned voice to have. For example, if the reference audio has no natural pauses or breaks in it, then the cloned voice won't be good at pausing.",
    'A good prompt is more excited and energetic than monotone and bored, so that the model will take cues to replicate this energy.',
];
